<template>
  <div :class="$style.collect">
    <h1>充值中心</h1>
    <ul>
      <li v-for="(item, index) in gameList" :key="index">
        <img :src="item.icon" alt="" />
        <div>
          <p>{{ item.text }}</p>
          <p>{{ item.desc }}</p>
        </div>
        <button @click="redirectLink(item)">点击充值</button>
      </li>
    </ul>
    <div :class="$style.selectOsMask" v-if="selectVisible">
      <div :class="$style.selectOs">
        <h1>请选择操作系统</h1>
        <div :class="$style.content">
          <CSelect placeholder="请选择操作系统" :options="osList" :value="os" @change="handleOsChange"></CSelect>
        </div>
        <div :class="$style.btnGroup">
          <Button :class="$style.cancel" @click="$emit('close')">取消</Button>
          <Button :class="$style.nextStep" @click="selectOs">确定</Button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Bind from './bind';
import { Popup, Button } from 'vant';
import CSelect from '@/components/Select';

export default {
  name: '',
  data() {
    return {
      gameList: [],
      defaultList: {
        android: [
          {
            text: '帝王荣耀',
            value: 'offlinePay.dwryAndroid',
            desc: '热血开篇，昔日兄弟回归！初心不改、完美复刻战法道！良心策划吐血大作，热血超变强势来袭！',
            icon: '//static.hzwxbz3.cn/Lianyun/font_end/wap/offlinePay/icon/lyy.png'
          }
        ],
        ios: [
          {
            text: '至尊无极-吾皇问世',
            value: 'offlinePay.zzwj',
            desc: '成不世功业，成就勇士传奇，为了荣誉和霸业而战！极品神器，毁天灭地！',
            icon: '//static.hzwxbz3.cn/Lianyun/font_end/wap/offlinePay/icon/zzwj.png'
          },
          {
            text: '怒战皇城-荣耀至尊',
            value: 'offlinePay.wzcs',
            desc: '荣耀的世界里面，炫酷装备，超爽豪礼全都有，在这里寻找属于自己的至尊，和伙伴肩并肩在皇城战斗吧！',
            icon: '//static.hzwxbz3.cn/Lianyun/font_end/wap/offlinePay/icon/ryzz.png'
          },
          {
            text: '破晓开天之怒战雷霆',
            value: 'offlinePay.cy',
            desc: '爆装不等待，要爽就现在！处处都掉宝，神装遍地捡！指尖激情四射，战场谁与争霸！',
            icon: '//static.hzwxbz3.cn/Lianyun/font_end/wap/offlinePay/icon/cy.png'
          },
          {
            text: '热血至尊之超燃之战',
            value: 'offlinePay.rxzz',
            desc: '极品的神技，让你在刷图时全图秒杀，战到你爽。',
            icon: '//static.hzwxbz3.cn/Lianyun/font_end/wap/offlinePay/icon/rxzz.png'
          },
          {
            text: '帝王荣耀：荣耀之怒',
            value: 'offlinePay.lyytj',
            desc: '无上霸权荣耀由战斗铸就，和好兄弟一起奋斗，热血荣耀由你来创造！',
            icon: '//static.hzwxbz3.cn/Lianyun/font_end/wap/offlinePay/icon/lyy.png'
          },
          {
            text: '帝王荣耀：乱世龙魂',
            value: 'offlinePay.lslh',
            desc: '经典战斗沙城燃烧的岁月，回归经典的玩法！',
            icon: '//static.hzwxbz3.cn/Lianyun/font_end/wap/offlinePay/icon/lslh.png'
          },
          {
            text: '一战称王之斗战国',
            value: 'offlinePay.zzby',
            desc: '一战称王，建立你的霸业王图！造就一代神话，承载了一代人的记忆！',
            icon: '//static.hzwxbz3.cn/Lianyun/font_end/wap/offlinePay/icon/yzcw.png'
          }
        ]
      },
      osList: [
        { text: '安卓', value: 'android' },
        { text: 'ios', value: 'ios' }
      ],
      game: '',
      os: '',
      selectVisible: true
    };
  },
  methods: {
    redirectLink(item) {
      this.$router.push({ name: item.value });
    },
    handleOsChange({ text, value }) {
      this.os = value;
    },
    selectOs() {
      this.gameList = this.defaultList[this.os];
      this.selectVisible = false;
    }
  },
  components: {
    Bind,
    Popup,
    CSelect,
    Button
  }
};
</script>

<style lang="scss" module>
.collect {
  > h1 {
    font-size: 16px;
    color: #cc1109;
    position: relative;
    padding-left: 10px;
    height: 25px;
    line-height: 25px;
    &::before {
      position: absolute;
      content: ' ';
      top: 0;
      left: 0;
      width: 4px;
      height: 100%;
      background: #cc1109;
    }
  }
  > ul {
    > li {
      display: flex;
      align-items: center;
      padding: 15px 10px;
      border-bottom: 1px solid #d9d9d9;
      > img {
        width: 53px;
        height: 53px;
        margin-right: 4px;
      }
      > div {
        > p:nth-child(1) {
          font-size: 16px;
          margin-bottom: 5px;
        }
        > p:nth-child(2) {
          color: #878787;
          font-size: 12px;
        }
      }
      > button {
        flex: none;
        width: 75px;
        height: 29px;
        background: #cc1109;
        color: #ffffff;
        border: none;
        border-radius: 3.5px;
      }
    }
  }
  .selectOsMask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0);
  }
  .selectOs {
    width: 278px;
    height: 210px;
    border-radius: 6px;
    // overflow: hidden;
    background: #ffffff;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    > h1 {
      width: 100%;
      height: 41px;
      text-align: center;
      background-color: #cc1109;
      color: #ffffff;
      font-size: 17px;
      // font-weight: bold;
      // border-radius: 6px;
      line-height: 41px;
    }
    .content {
      padding: 15px;
      > p {
        color: #666666;
        font-size: 14px;
        margin-bottom: 6px;
      }
      .field {
        background-color: #e0e0e0;
        border: none;
        padding: 4px 8px;
        margin-bottom: 10px;
      }
      :global {
        .yw-select-wrap {
          width: 100%;
          background-color: #e0e0e0;
          color: #b4afaf;
        }
      }
    }
    .btnGroup {
      position: absolute;
      bottom: 15px;
      left: 15px;
      right: 15px;
      display: flex;
      justify-content: space-between;
      .cancel,
      .nextStep {
        width: 111px;
        height: 38px;
        border-radius: 6px;
      }
      .cancel {
        border: 1px solid #b2b2b2;
        color: #999999;
      }
      .nextStep {
        background: #cc1109;
        color: #ffffff;
      }
    }
  }
}
</style>
